import { render } from "./index.vue?vue&type=template&id=078458ec&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=078458ec&lang=less&scoped=true"

import exportComponent from "F:\\project\\trade_lab_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-078458ec"]])

export default __exports__